import React from 'react';

const LightBulbIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
    <path
      d='M20.7665 19.6603C22.1661 18.398 23 16.5907 23 14.7261C23 12.8616 22.1959 11.0829 20.7962 9.82059C19.3668 8.52973 17.5202 7.89857 15.5548 8.01327C12.0109 8.21417 9.12222 11.0829 9.0031 14.4965C8.94348 16.4471 9.74761 18.3118 11.2069 19.6314C11.7132 20.0905 12.0704 20.7216 12.279 21.3813L15.4058 21.3817V18.3984L13.8871 16.9354C13.6488 16.7059 13.6488 16.3617 13.8871 16.1322C14.1253 15.9027 14.4826 15.9027 14.7209 16.1322L15.9717 17.337L17.2225 16.1322C17.4608 15.9027 17.8181 15.9027 18.0564 16.1322C18.2947 16.3617 18.2946 16.7059 18.0564 16.9354L16.5971 18.3984V21.4106H19.7241C19.9027 20.722 20.26 20.1195 20.7665 19.6605L20.7665 19.6603Z'
      fill='currentColor'
    />
    <path
      d='M12.4279 22.5576C12.4279 23.5043 13.232 26 14.2148 26H17.7884C18.7712 26 19.5754 23.5043 19.5754 22.5576H12.4279Z'
      fill='currentColor'
    />
    <path
      d='M18.6471 4.40472C18.7186 4.13798 18.9927 3.97969 19.2595 4.05116C19.5262 4.12263 19.6845 4.3968 19.613 4.66353L19.0954 6.59539C19.0239 6.86212 18.7497 7.02041 18.483 6.94894C18.2163 6.87747 18.058 6.6033 18.1294 6.33657L18.6471 4.40472Z'
      fill='currentColor'
    />
    <path
      d='M12.1294 4.6635C12.0579 4.39677 12.2162 4.1226 12.483 4.05113C12.7497 3.97966 13.0239 4.13795 13.0953 4.40469L13.613 6.33654C13.6844 6.60327 13.5262 6.87744 13.2594 6.94891C12.9927 7.02038 12.7185 6.86209 12.647 6.59536L12.1294 4.6635Z'
      fill='currentColor'
    />
    <path
      d='M6.35355 8.1464C6.15829 7.95114 6.15829 7.63456 6.35355 7.43929C6.54882 7.24403 6.8654 7.24403 7.06066 7.43929L8.47487 8.85351C8.67014 9.04877 8.67014 9.36535 8.47487 9.56061C8.27961 9.75588 7.96303 9.75588 7.76777 9.56061L6.35355 8.1464Z'
      fill='currentColor'
    />
    <path
      d='M4.3189 14.0954C4.05217 14.0239 3.89388 13.7497 3.96535 13.483C4.03682 13.2162 4.31099 13.058 4.57772 13.1294L6.50957 13.6471C6.7763 13.7185 6.9346 13.9927 6.86312 14.2594C6.79165 14.5262 6.51749 14.6845 6.25075 14.613L4.3189 14.0954Z'
      fill='currentColor'
    />
    <path
      d='M5.57769 19.613C5.31096 19.6845 5.03679 19.5262 4.96532 19.2595C4.89385 18.9927 5.05214 18.7186 5.31887 18.6471L7.25072 18.1295C7.51746 18.058 7.79162 18.2163 7.86309 18.483C7.93457 18.7497 7.77627 19.0239 7.50954 19.0954L5.57769 19.613Z'
      fill='currentColor'
    />
    <path
      d='M26.6737 18.6471C26.9404 18.7186 27.0987 18.9927 27.0272 19.2595C26.9557 19.5262 26.6816 19.6845 26.4148 19.613L24.483 19.0954C24.2162 19.0239 24.058 18.7497 24.1294 18.483C24.2009 18.2163 24.4751 18.058 24.7418 18.1294L26.6737 18.6471Z'
      fill='currentColor'
    />
    <path
      d='M27.4149 13.1294C27.6816 13.0579 27.9558 13.2162 28.0272 13.483C28.0987 13.7497 27.9404 14.0239 27.6737 14.0953L25.7418 14.613C25.4751 14.6844 25.2009 14.5262 25.1295 14.2594C25.058 13.9927 25.2163 13.7185 25.483 13.647L27.4149 13.1294Z'
      fill='currentColor'
    />
    <path
      d='M24.7678 7.43925C24.963 7.24398 25.2796 7.24398 25.4749 7.43925C25.6702 7.63451 25.6702 7.95109 25.4749 8.14635L24.0607 9.56057C23.8654 9.75583 23.5488 9.75583 23.3536 9.56057C23.1583 9.3653 23.1583 9.04872 23.3536 8.85346L24.7678 7.43925Z'
      fill='currentColor'
    />
  </svg>
);

export default LightBulbIcon;
